<!-- 公共多上传文件 -->
<template>
  <div class="PublicMoreUpload" id="PublicMoreUpload">
    <div class="UploadTitle">
      {{$t('lang.fromUrl')}}
    </div>
    <div class="ManualInput">
      <el-input v-model="ManualInputUrl" :placeholder="$t('lang.EnterURL')" :disabled="AddUrlLoading" @change="UrlTrim" clearable />
      <div class="AddButton">
        <el-button size="small" type="primary" @click="AddUrl" v-loading="AddUrlLoading">{{$t('lang.add')}}</el-button>
      </div>
    </div>
    <div class="UploadTitle">
      {{$t('lang.fromComputer')}}
    </div>
    <div class="upload_p">
      <el-upload
        ref="loadControl"
        class="upload"
        action="#"
        :multiple="true"
        :show-file-list="false"
        :accept="UploadConfig.accept"
        :http-request="uploadFileBySDK"
      >
        <el-button size="small" type="primary">{{
          $t('lang.upload')
        }}</el-button>
      </el-upload>
      <div class="Format" v-if="UploadConfig.supportFormat">
        {{ UploadConfig.supportFormat }}
      </div>
      <div class="videoList">
        <div
          class="uploadMessage"
          v-for="(item, index) in fileList"
          :key="index + item.name + item.uid"
        >
          <div class="uploadStatus">
            <div
              :style="{
                color: item.status == 'success' ? '#DBDBDB' : '#666666',
              }"
            >
             <span>{{ item.name }}</span>
            </div>
            <div class="Status">
              <i v-if="item.status == 'success'" class="el-icon-success"></i>
              <i
                v-if="item.status == 'upload'"
                class="el-icon-close"
                @click="cancelVideo(item, index)"
              ></i>
            </div>
          </div>
          <el-progress
            v-if="item.status != 'success'"
            :stroke-width="4"
            :percentage="item.percentage"
          ></el-progress>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Outil from '@/assets/js/utils.js'
import toTips from '@/assets/js/toTipsObj'
export default {
  props: {
    // 必传 region信息
    awsInfo: {
      type: Object,
      default: () => ({
        bucket: 'pp-va-001',
        region: 'us-east-1',
        ServerName: 'Channel'
      })
    },
    // 必传
    OwnerUserid: {
      type: String,
      default: ''
    },
    // 必传
    programId: {
      type: String,
      default: ''
    },
    // 上传配置
    UploadConfig: {
      type: Object,
      default: () => ({
        // 上传格式
        accept: '',
        // 支持格式提示
        supportFormat: '',
        // 上传文件夹
        UploadFolder: '/Playout',
        // 宽高限制
        HeightLimitWidth: {
          width: 1920,
          height: 1080
        }
      })
    }
  },
  data () {
    return {
      // 文件上传列表
      fileList: [],
      // 输入外部链接
      ManualInputUrl: '',
      AddUrlLoading: false
    }
  },
  created () {},
  mounted () {},
  methods: {
    // 去除空格
    UrlTrim () {
      this.ManualInputUrl = this.ManualInputUrl.trim()
    },
    // 添加链接
    AddUrl () {
      if (!this.ManualInputUrl) {
        this.$message.error(this.$t('lang.BackgroundLink'))
        return
      }
      if (this.ManualInputUrl.length > 2000) {
        this.$message.error(this.$t('lang.BackgroundLinkSize'))
        return
      }
      const reg = /(http|https):\/\/([\w.]+\/?)\S*/
      if (!reg.test(this.ManualInputUrl)) {
        // 校验成功
        this.$message.error(this.$t('lang.pleaseInputCorrectUrl'))
        return
      }
      if (/.*(\.png|\.jpg|\.jpeg|\.gif|\.PNG|\.JPG|\.JPEG|\.GIF)$/g.test(this.ManualInputUrl)) {
        const HeightLimitWidth = this.UploadConfig.HeightLimitWidth
        const ImgObj = new Image()
        ImgObj.src = this.ManualInputUrl
        ImgObj.onerror = () => {
          this.$message.error(this.$t('lang.pleaseInputCorrectUrl'))
        }
        ImgObj.onload = () => {
          // if (ImgObj.width == HeightLimitWidth.width && ImgObj.height == HeightLimitWidth.height) {
          this.$emit('ExternalLinkAdd', this.ManualInputUrl)
          this.ManualInputUrl = ''
          this.$message.success(this.$t('lang.success'))
          // } else {
          //   this.$message.warning(this.$t('lang.BackUpload', { width: HeightLimitWidth.width, height: HeightLimitWidth.height }))
          // }
        }
      } else {
        this.$emit('ExternalLinkAdd', this.ManualInputUrl)
        this.ManualInputUrl = ''
        this.$message.success(this.$t('lang.success'))
      }
    },
    async uploadFileBySDK (file) {
      const FileObject = {
        name: file.file.name,
        percentage: 0,
        raw: file.file,
        uid: file.file.uid,
        status: 'upload',
        data: null
      }
      const ContentType = file.file.type ? file.file.type : null
      const HeightLimitWidth = this.UploadConfig.HeightLimitWidth
      if (HeightLimitWidth) {
        let UpToStandard = true
        await this.JudgmentConformity(file.file).then((data) => {
          if (!(data.width == HeightLimitWidth.width && data.height == HeightLimitWidth.height)) {
            UpToStandard = false
          }
        }).catch(() => {})
        if (!UpToStandard) {
          this.$message.warning(this.$t('lang.BackUpload', { width: HeightLimitWidth.width, height: HeightLimitWidth.height }))
          return
        }
      }
      this.fileList.push(FileObject)
      const params = {
        region: this.awsInfo.region,
        service: this.awsInfo.ServerName,
        bucketId: this.awsInfo.bucketId,
        directoryName: this.UploadConfig.UploadFolder,
        fileName: FileObject.name,
        userId: this.OwnerUserid
      }
      this.$http
        .post('/file/request-upload-for-sdk', params, {
          requestBase: 'GATEWAY'
        })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            const { result } = res.data
            AWS.config.region = result.identityPoolRegion
            AWS.config.credentials = new AWS.CognitoIdentityCredentials({
              IdentityPoolId: result.identityPoolId
            })
            this.doUploadFile(result, FileObject, ContentType)
          }
        })
        .catch(() => {})
    },
    //   判断图片是否合格
    JudgmentConformity (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = function (evt) {
          const image = new Image()
          const mapPictureSize = {}
          image.onload = function () {
            mapPictureSize.type = 1
            mapPictureSize.width = this.width
            mapPictureSize.height = this.height
            resolve(mapPictureSize)
          }
          image.onerror = function () {
            mapPictureSize.type = 0
            reject(mapPictureSize)
          }
          image.src = evt.target.result
        }
        reader.readAsDataURL(file)
      })
    },
    doUploadFile (obj, FileObject, ContentType) {
      FileObject.data = new AWS.S3.ManagedUpload({
        params: {
          Bucket: obj.bucket,
          Key: obj.objectKey,
          Body: FileObject.raw,
          ACL: 'public-read', // 固定
          ContentType
        },
        service: new AWS.S3({
          region: obj.region
        })
      })
      FileObject.data.on('httpUploadProgress', (event) => {
        FileObject.percentage = Math.floor((event.loaded * 100) / event.total)
        if (FileObject.percentage == 100) {
          FileObject.percentage = 99
        }
      })
      FileObject.data.promise().then((data) => {
        this.saveResult(obj, FileObject)
      })
    },
    saveResult (obj, FileObject) {
      const params = {
        bucketId: obj.bucketId,
        directoryId: obj.directoryId,
        objectKey: obj.objectKey
      }
      this.axios
        .post('/file/add-file', params, { requestBase: 'GATEWAY' })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            FileObject.percentage = 100
            FileObject.status = 'success'
          } else {
            FileObject.status = 'failed'
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        })
        .catch(() => {})
    },
    // 取消视频上传
    cancelVideo (item, index) {
      if (item.status == 'upload') {
        item.data && item.data.abort()
        this.fileList.splice(index, 1)
      }
    },
    // 取消文件上传
    cancelUploadedVideo (done) {
      let AllUpload = true
      this.fileList.forEach((item) => {
        if (item.status == 'upload') {
          AllUpload = false
        }
      })
      if (!AllUpload) {
        this.$confirm(this.$t('lang.CancelUpload'), '', {
          confirmButtonText: this.$t('lang.Confirm'),
          cancelButtonText: this.$t('lang.cancel'),
          type: ''
        }).then(() => {
          this.fileList.forEach((item) => {
            if (item.status == 'upload') {
              item.data.abort()
            }
          })
          done()
        }).catch(() => {})
      } else {
        done()
      }
    }
  }
}
</script>

<style scoped lang="less">
#PublicMoreUpload {
  .ManualInput {
    margin-bottom: 55px;
    ::v-deep .el-input__inner  {
      width: 100%;
      height: 32px;
      line-height: 32px;
      background: #444444;
      border-radius: 4px;
      border: 1px solid #353535;
    }
    ::v-deep input::-webkit-input-placeholder {
      color: #666666;
    }
    .AddButton{
      text-align: right;
      margin-top: 20px;
    }
    ::v-deep .el-button--primary {
      width: 65px;
      margin-left: 16px;
      background-color: #5dc045;
      border: 1px solid #5dc045;
      .el-loading-mask{
        .el-loading-spinner{
          margin-top: -7px;
          .circular{
            height: 16px;
            width: 16px;
          }
        }
      }
    }
  }
}
.PublicMoreUpload {
  text-align: left;
  // padding-bottom: 25px;
  line-height: normal;
  .UploadTitle{
    margin-top: 25px;
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: 600;
    color: #959595;
  }
  .upload_p {
    ::v-deep .el-button {
      width: 80px;
      height: 32px;
      padding: 0;
      background-color: #5dc045;
      border: 1px solid #5dc045;;
      span {
        font-size: 14px;
        color: #ffffff;
        font-weight: normal;
      }
    }
    .Format {
      font-size: 15px;
      line-height: 1;
      color: #959595;
      margin-top: 10px;
      margin-bottom: 10px;
    }
    ::v-deep .videoList {
      width: 100%;
      margin-bottom: 5px;
      margin-top: 10px;
      .uploadMessage {
        margin-bottom: 10px;
        .uploadStatus {
          display: flex;
          justify-content: space-between;
          span {
            font-size: 12px;
          }
          .el-icon-success {
            color: #39aa50;
          }
          .el-icon-close {
            color: #fff;
            display: none;
          }
        }
      }
      .uploadMessage:hover .el-icon-close {
        display: inline-block;
      }
      .uploadMessage:hover .el-progress__text {
        display: none;
      }
      .el-progress {
        .el-progress__text {
          position: absolute;
          right: 0px;
          top: -15px;
          font-size: 18px;
          color: #fff;
        }
        .el-progress-bar {
          padding-right: 0px;
        }
      }
    }
  }
}
</style>
